export class Application {}

export const APPLICATION_STATE_SYMBOL = Symbol.for("@visactor/vrender-core/application-state");

function createApplicationState() {
    return {
        application: new Application
    };
}

export function getApplicationState() {
    const scope = globalThis;
    return scope[APPLICATION_STATE_SYMBOL] || (scope[APPLICATION_STATE_SYMBOL] = createApplicationState()), 
    scope[APPLICATION_STATE_SYMBOL];
}

export const application = getApplicationState().application;